/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import GuardianRouteLinkItem from './GuardianRouteLinkItem';
import EnrollmentIcon from 'icons/EnrollmentIcon';

const messages = defineMessages({
  title: {id: 'navigation.school-membership'},
});

const SchoolMembershipItem = () => (
  <GuardianRouteLinkItem
    iconBefore={EnrollmentIcon}
    route="midas/guardian/school-membership"
    title={messages.title}
  />
);

export default SchoolMembershipItem;
